<template>
  <li>
    <router-link v-if="$userIsAdmin" :to="{ name: 'users.edit', params: { id: coordinator.id } }" >
      <CoordinatorInfo :coordinator="coordinator" />
    </router-link>
    <a href="javascript:;" v-if="$userIsCoordinator">
      <CoordinatorInfo :coordinator="coordinator" />
    </a>

    <button @click="removeCoordinatorFromAgency" v-if="$userIsAdmin" class="btn text-danger">
      <font-awesome :icon="['far', 'trash']" fixed-width/>
    </button>
  </li>
</template>

<script>
import { agencyComputed, agencyMethods } from 'vx/helpers'
import { first } from 'lodash'
import { alert, handleServerErrors } from 'utils'
import CoordinatorInfo from './AgenciesSingleCoordinatorsListItemInfo'

export default {
  props: {
    coordinator: {
      required: true,
      type: Object
    }
  },

  components: {
    CoordinatorInfo
  },

  computed: {
    ...agencyComputed
  },

  methods: {
    ...agencyMethods,

    async removeCoordinatorFromAgency () {
      const confirm = await alert.confirm({
        title: 'Remove Coordinator?',
        text: `Are you sure you want to remove this Agency Coordinator from ${this.agency.name}? Please ensure to also disable the user's account if they are no longer an active coordinator.`,
        buttons: {
          confirm: {
            className: 'btn btn-danger btn-rounded'
          }
        }
      })

      if (confirm) {
        try {
          await this.removeCoordinator({ agency: this.agency, coordinator: this.coordinator })

          this.$noty.success('Coordinator removed.')
        } catch (error) {
          handleServerErrors(error, this.$validator)

          this.$noty.error(`<strong>Unable to remove coordinator:</strong> <em><br>${first(this.errors.items).msg}</em>`)
        }
      }
    }
  }
}
</script>
